var exports = {
  "kL": "x127c5a35--d34314--container",
  "Fi": "x127c5a35--d34314--container-new-item",
  "DD": "x127c5a35--d34314--title",
  "Sl": "x127c5a35--d34314--image",
  "kW": "x127c5a35--d34314--container-selected",
  "rf": "x127c5a35--d34314--body",
  "h_": "x127c5a35--d34314--description",
};

module.exports = exports;
